if not App.angularApp?
    return

App.angularApp.directive 'mfUibBtnRadio', ->
    require: ['ngModel', 'uibBtnRadio']
    restrict: 'A'
    link: (scope, ele, attrs, ctrls) ->
        ngModelCtrl = ctrls[0]
        uibBtnRadioRender = ngModelCtrl.$render
        valToCheckAgainstModel = scope.$eval attrs.uibBtnRadio
        customClasses = scope.$eval attrs.mfUibBtnRadio
        classesToToggle = customClasses or 'btn-primary'
        ngModelCtrl.$render = () ->
            isEqual = angular.equals ngModelCtrl.$modelValue, valToCheckAgainstModel
            ele.toggleClass classesToToggle, isEqual
            uibBtnRadioRender()
